import { UpdateAccountingPostingPayload } from '@module/workflow/workflow.interface';

export class HoldInvoice {
  static readonly type = '[IncomingModule] HoldInvoice';
  constructor(
    public id: number,
    readonly action = 'Hold',
    readonly fn = 'holdInvoice'
  ) {}
}

export class ApproveInvoice {
  static readonly type = '[IncomingModule] ApproveInvoice';
  constructor(
    public id: number,
    readonly action = 'Approved',
    readonly fn = 'approveInvoice'
  ) {}
}

export class SignInvoice {
  static readonly type = '[IncomingModule] SignInvoice';
  constructor(
    public id: number,
    readonly action = 'Signed',
    readonly fn = 'signInvoice'
  ) {}
}

export class CancelInvoice {
  static readonly type = '[IncomingModule] CancelInvoice';
  constructor(
    public id: number,
    readonly action = 'Cancelled',
    readonly fn = 'cancelInvoice'
  ) {}
}

export class ReleaseInvoice {
  static readonly type = '[IncomingModule] ReleaseInvoice';
  constructor(
    public id: number,
    readonly action = 'Release',
    readonly fn = 'releaseInvoice'
  ) {}
}

export class ReleaseInvoiceToERP {
  static readonly type = '[IncomingModule] ReleaseInvoiceToERP';
  constructor(
    public id: number,
    readonly action = 'release_to_erp',
    readonly fn = 'releaseInvoiceToERP'
  ) {}
}

export class ReassignInvoice {
  static readonly type = '[IncomingModule] ReassignInvoice';
  constructor(
    public invoiceId: number,
    public userId: number
  ) {}
}

export class AssignUnassignedInvoice {
  static readonly type = '[IncomingModule] AssignUnassignedInvoice';
  constructor(
    public invoiceId: number,
    public userId: number
  ) {}
}

export class GetCurrentInvoiceData {
  static readonly type = '[IncomingModule] GetCurrentInvoiceData';
  constructor(public invoiceId: number) {}
}

export class ResetInvoiceState {
  static readonly type = '[IncomingModule] ResetInvoiceState';
}

export class QuarantineCurrentInvoice {
  static readonly type = '[IncomingModule] QuarantineCurrentInvoice';
  constructor(public invoiceId: number) {}
}

export class CancelQuarantineCurrentInvoice {
  static readonly type = '[IncomingModule] CancelQuarantineCurrentInvoice';
}

export class CompleteQuarantineCurrentInvoice {
  static readonly type = '[IncomingModule] CompleteQuarantineCurrentInvoice';
  constructor(public invoiceId: number) {}
}

export class ViewIncomingInvoiceAsPDF {
  static readonly type = '[IncomingModule] ViewIncomingInvoiceAsPDF';
  constructor(public invoiceId: number) {}
}

export class DownloadIncomingInvoiceAsPDF {
  static readonly type = '[IncomingModule] DownloadIncomingInvoiceAsPDF';
  constructor(public invoiceId: number) {}
}

export interface InvoiceActions extends HoldInvoice, ApproveInvoice, SignInvoice, ReleaseInvoice, CancelInvoice {}

export class IncomingStateClearTagTypeCache {
  static readonly type = '[IncomingModule] ClearTagTypeCache';
}

export class CancelIncomingInvoiceRequests {
  static readonly type = '[IncomingModule] CancelIncomingInvoiceRequests';
}

export class GetAccounts {
  static readonly type = '[IncomingModule] GetAccounts';
}

export class GetDimensions {
  static readonly type = '[IncomingModule] GetDimensions';
}

export class GetPostings {
  static readonly type = '[IncomingModule] GetPostings';
  constructor(public globalTransactionId: string) {}
}

export class UpdatePostings {
  static readonly type = '[IncomingModule] UpdatePostings';
  constructor(
    public globalTransactionId: string,
    public payload: UpdateAccountingPostingPayload
  ) {}
}
